/**
 * 底部弹框组件
 * author: wangbo16
 */
import React from 'react';
import ReactDOM from 'react-dom';

import './index.scss';

interface IPopUpProps {
  content?: string | React.ReactNode;
  nowrap?: boolean;
  position?: 'top' | 'center' | 'bottom';
  duration?: number;
}

const Toast = (props: IPopUpProps) => {
  const { content, nowrap, position } = props;
  const className = nowrap
    ? `toast-container toast-nowrap toast-position-${position}`
    : `toast-container toast-position-${position}`;
  return <div className={className}>{content || '...'}</div>;
};

export default {
  show(
    content,
    { duration = 2000, nowrap = false, position = 'center' }: IPopUpProps = {
      duration: 2000,
      nowrap: false,
      position: 'center'
    }
  ) {
    let domNode = document.getElementById('root-toast');
    let success: any = Promise.resolve;

    if (domNode) {
      ReactDOM.render(
        <Toast content={content} nowrap={nowrap} position={position} />,
        domNode
      );
    } else {
      domNode = document.createElement('div');
      domNode.id = 'root-toast';
      document.body.appendChild(domNode);
      ReactDOM.render(
        <Toast content={content} nowrap={nowrap} position={position} />,
        domNode
      );

      setTimeout(() => {
        ReactDOM.unmountComponentAtNode(domNode as Element);
        document.body.removeChild(domNode as Element);
        success();
      }, duration);
    }

    return new Promise((resolve) => {
      success = resolve;
    });
  }
};
